// extracted by mini-css-extract-plugin
export default {"column":"madDovVuhDQn7Z9RlUW4-Column-column","reverseDirectionInMobile":"HWe4v_6t9YKCNYkyuINg-Column-reverseDirectionInMobile"};